export default __webpack_public_path__ + "static/media/express-js-logo-1.4ddc104d.svg";